import React, { useState, useEffect, useRef } from 'react';

import { ChevronDownIcon, ProgressHoldIcon } from '../SVGIcons/SVGIcons';

export default function StatusSwitcher({
	value,
	disabledStatuses = [],
	onChange,
	resource,
	statuses,
	message,
	noDropdown,
	hold,
}) {
	const [open, setOpen] = useState(false);
	const dropdownRef = useRef(null);

	const currentStatus = statuses.find((s) => s.value === value);
	const CurrentIcon = currentStatus?.icon || null;

	useEffect(() => {
		function handleClickOutside(event) {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setOpen(false);
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleSelect = (resource, status, message) => {
		if (disabledStatuses.includes(status?.value)) return;
		onChange?.(resource, status.value, message);
		setOpen(false);
	};

	return (
		<div className={`status-switcher`} ref={dropdownRef}>
			{hold?.holdStartDate && !hold?.holdEndDate ? (
				<div className='holdTag'>
					<ProgressHoldIcon iconClass='holdIcon' />
					<h4>On hold</h4>
				</div>
			) : (
				<></>
			)}
			<button
				onClick={() => setOpen(!open)}
				className={`status-button ${currentStatus?.className}${noDropdown ? ' noDropdown' : ''}`}>
				{CurrentIcon && <CurrentIcon iconClass='status-icon' />}
				<h4>{currentStatus?.label}</h4>
				{noDropdown !== true ? <ChevronDownIcon iconClass='chevron-icon' /> : <></>}
			</button>

			{open && noDropdown !== true && (
				<ul className='status-dropdown'>
					{statuses
						.filter((status) => !disabledStatuses.includes(status.value))
						.map((status) => (
							<li
								key={status.key}
								onClick={() => handleSelect(resource, status, message)}
								className={`status-option ${status.key === currentStatus?.key ? 'selected' : ''} ${
									status.className
								}`}>
								<status.icon iconClass='status-icon' />
								<h4>{status.label}</h4>
							</li>
						))}
				</ul>
			)}
		</div>
	);
}
